import { Grid } from "@mui/material";
import { Fragment, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  cardDisplayRoutes,
  getMatchingRoutes,
} from "../../Constants/CommonConstants";

import { StyledPrimaryContainer } from "../../Styles/Application/RoutesLayoutStyles";
import {
  StyledMyProfileBox,
  StyledMyProfileDetailsBox,
} from "../../Styles/MyProfile/MyProfile";
import MyProfileSideNav from "./MyProfileSideNav";

const MyProfileWrapper = () => {
  const location = useLocation();

  const isCardDisplay = useMemo(() => {
    return getMatchingRoutes(location.pathname, cardDisplayRoutes);
  }, [location.pathname]);

  return (
    <Fragment>
      {!isCardDisplay ? (
        <StyledMyProfileBox>
          <StyledPrimaryContainer>
            <Grid container columnSpacing={6} rowSpacing={4}>
              <Grid item xs={12} md={4}>
                <MyProfileSideNav />
              </Grid>
              <Grid item xs={12} md={8}>
                <StyledMyProfileDetailsBox>
                  <Outlet />
                </StyledMyProfileDetailsBox>
              </Grid>
            </Grid>
          </StyledPrimaryContainer>
        </StyledMyProfileBox>
      ) : (
        <Outlet />
      )}
    </Fragment>
  );
};

export default MyProfileWrapper;
